import { render } from "./ContactsAdd.vue?vue&type=template&id=3b8dd061"
import script from "./ContactsAdd.vue?vue&type=script&lang=js"
export * from "./ContactsAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__